import { Component, input, model, output } from '@angular/core';

import { InfoCardType } from '../../../../../model/info-card-type.enum';
import { InfoCardTitleComponent } from '../info-card-title/info-card-title.component';

@Component({
  selector: 'lib-ikp-info-card-section',
  standalone: true,
  imports: [InfoCardTitleComponent],
  templateUrl: './info-card-section.component.html',
  styleUrl: './info-card-section.component.scss',
})
export class InfoCardSectionComponent {
  infoCardType = input<InfoCardType>(null);
  title = input<string>(null);
  truncateTitle = input<boolean>(true);
  subtitle = input<string>(null);
  iconPath = input<string>(null);
  isCheckbox = input<boolean>(null);
  isChecked = input<boolean>(null);
  actionText = input<string>(null);
  actionColor = input<string>('orange');
  actionIcon = input<string>(null);
  readonly actionClicked = output<void>();
  isCollapsed = model<boolean>();
  index = input<number>();

  onActionClicked() {
    this.actionClicked.emit();
  }
}
